// Axios wrappers for the RFP "proposal section templates" API
// (backend: rfp/views/proposal_templates.py). These are reusable TOC-style
// scaffolds — a named list of sections/subsections — scoped to the active
// workspace via the selected_org_id cookie, mirroring templatesApi's data layer.
import Cookies from "js-cookie";
import api from "../pages/chat/api";

const BASE = "/api/v1/rfp/proposal-templates";

const orgId = () => Cookies.get("selected_org_id");

// This endpoint requires organization_id as a query param on every call.
const withOrg = (path) => {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}organization_id=${orgId()}`;
};

// GET list of proposal section templates visible to the caller in this org
// (their own personal ones + every organization-wide one).
// Response: { results: [...], total, organization_id }. We return `results`.
export const listProposalSections = () =>
  api.get(withOrg(`${BASE}/`)).then((r) => r.data?.results || []);

// POST create a template. Payload: { name, visibility: 'personal'|'organization',
// sections: [{ title, section_query?, subsections: [{ title }] }] }. The backend
// drops empty titles and requires at least one non-empty section.
export const createProposalSection = (payload) =>
  api.post(withOrg(`${BASE}/`), payload).then((r) => r.data);

// PATCH a template (name / visibility / sections). Only the creator or an org
// admin may edit (else 403).
export const updateProposalSection = (id, payload) =>
  api.patch(withOrg(`${BASE}/${id}/`), payload).then((r) => r.data);

// DELETE a template. Only the creator or an org admin may delete (else 403).
export const deleteProposalSection = (id) =>
  api.delete(withOrg(`${BASE}/${id}/`)).then((r) => r.data);
